import { Utils } from '../../../../helpers'

export class PresenterFactory {
  public constructor(
    private _presenters,
    private _utils
  ) {
    this._presenters = this._presenters
      .reduce((classObject, klass) => {
        classObject[klass.name.toLowerCase()] = klass
        return classObject
      }, {})
  }

  public get(modelName: string) {
    const presenterClassString = `${this._utils.pascalCase(this._utils.singularize(modelName))}presenter`.toLowerCase()
    const presenterClass = this._presenters[presenterClassString]

    if (typeof presenterClass === 'undefined') {
      throw new Error(`No such Presenter defined in barrel file '${presenterClassString}'`)
    }

    return presenterClass
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/json-api-backend/presenters/presenter.factory.ts